import Group from './group'
import RadioElement from './radio'
import Button from './radioButton'

import './style/css'

const Radio = Object.assign(RadioElement, { Group, Button })

export default Radio
